import { Authorization, Fluent } from "@serenity-is/corelib";
import { IdleTimeout } from "@serenity-is/pro.extensions";

Fluent.ready(() => {
    // let demo page use its own settings for idle timeout
    if (window.location.pathname.indexOf('Samples/IdleTimeout') > 0)
        return;

    const envMeta = document.querySelector('meta[name=environment]') as HTMLMetaElement | null;
    const isDebug = (envMeta?.content === 'Development') ||
        location.hostname === 'localhost' ||
        location.hostname === '127.0.0.1' ||
        location.hostname.endsWith('.local') ||
        location.hostname.indexOf('.local')>0;

    if (isDebug) return; // 🔕 in debug niente IdleTimeout del tutto


    var meta = Fluent(document.querySelector('meta[name=username]'));
    if ((meta.attr('content')) || (!meta.length && Authorization.isLoggedIn)) {
        new IdleTimeout({
            activityTimeout: 4 * 60 * 60 - 2 * 60,  //15 * 60,          // durata sessione
            warningDuration: 2 * 60
        });
    }
});